import { PayloadAction } from "@reduxjs/toolkit";
import { IInitialState } from "./Types";

export const Reducer = {
  showProgressBar: (state: IInitialState, action: PayloadAction<string>): void => {
    state.text = action.payload;
    state.show = true;
  },
  hideProgressBar: (state: IInitialState): void => {
    state.text = "";
    state.show = false;
  }
};
